import React from 'react';
import {
    Grid,
    makeStyles,
    TextField,
    createStyles,
    Theme,
} from "@material-ui/core";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        containerLabel: {
            textAlign: "left",
        },
    })
);

export function PropertyTextFieldNumber(props: {
    id: string;
    label: string;
    name: string;
    value: string | number;
    key?: string | number;
    handleChange: (e: any) => void;
    placeholder?: string;
    inputProps?: React.ComponentProps<typeof TextField>['inputProps'];
}) {
    const classes = styles();
    const { id, label, name, value, key, handleChange, placeholder, inputProps } = props;

    // If value is an empty string, show the placeholder "0"
    const displayValue = value === '' ? '' : value.toString();

    return (
        <>
            <Grid
                item
                lg={12}
                sm={12}
                xs={12}
                className={classes.containerLabel}
            >
                <label htmlFor={id} className={classes.inputLabel}>
                    {label}
                </label>
            </Grid>
            <Grid item lg={12} sm={12} xs={12} className={classes.inpuText}>
                <TextField
                    id={id}
                    key={key}
                    fullWidth
                    name={name}
                    value={displayValue} // Use displayValue for input field
                    type="number"
                    InputProps={{
                        inputProps: {
                            min: 0, // Default min value
                            ...inputProps,
                        },
                        placeholder: value === '' ? placeholder || "0" : '',
                    }}
                    onChange={handleChange}
                    variant="outlined"
                />
            </Grid>
        </>
    );
}
